<template>
  <div
    v-loading="isLoad"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    class="f-df pd-row30 regional-distribution-model">
    <div id="china-map" class="china-map"></div>
    <div class="province-distribution-list mg-left15 flex-1">
      <no-data v-if="!provinceList.length && !isLoad" height="430" />
      <ul v-else>
        <li class="f-df province-distribution-item bor-btm-gray pd15 mg-btm5">
          <span
            :class="areaType === '1' ? 'color-blue' : ''"
            class="pd-right15 f-csp"
            @click="areaChoose('1')">
            省份
          </span>
          <span
            :class="areaType === '2' ? 'color-blue' : ''"
            class="province-title f-csp"
            @click="areaChoose('2')">
            城市
          </span>
          <span class="institu-sum f-tar mg-right30">达人数量</span>
          <span class="institu-rate"></span>
        </li>
        <li
          v-for="(item, index) in provinceList"
          v-show="index < 10"
          :key="index"
          class="f-df f-ai f-cl6 province-distribution-item pd-column10-row15">
          <span class="province-title f-df">
            <em class="f-fwn" style="width: 25px;">{{ index + 1 }}. </em>
            <em class="f-fwn"></em>{{ item.name }}
          </span>
          <span class="institu-sum f-tar mg-right15">{{ item.value }}</span>
          <div class="institu-rate f-pr flex-1">
            <p class="rate-btm"></p>
            <p :style="{width: item.rate}" class="rate-wid f-pa"></p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import noData from '@/components/nodata.vue'
// 导出城市拼音
// import provincePinyin from '@/assets/data/province-pinyin.json'
export default {
  components: {
    noData
  },
  props: {
    isLoad: {
      type: Boolean,
      default: false
    },
    areaType: {
      type: String,
      default: ''
    },
    provinceList: {
      type: Array,
      default: () => ([])
    }
  },
  watch: {
    provinceList: {
      handler(newArr) {
        this.getAreaMap(newArr)
      },
      // immediate: true, // 首次也监听
      deep: true
    }
  },
  methods: {
    // 切换省份城市
    areaChoose(type) {
      this.$emit('areaChoose', type)
    },
    // 区域分布地图
    getAreaMap(result) {
      if (this.areaType * 1 !== 1) return
      axios.get('/static/mapChina.json').then(res => {
        this.$echarts.registerMap('china', res.data)
        const maxNum = result.length ? result[0].value || 0 : 0
        const color = ['#326CFA', '#7198f7', '#33c6f7', '#b0e9fc', '#d9f4fe', '#f2f2f2']
        const emphasisColor = ['#1c5cf9', '#5585f8', '#38d9ff', '#c1ffff', '#eeffff', '#ddd']
        // const emphasisColor = ['#1c5cf9', '#5585f8', '#38d9ff', '#c1ffff', '#eeffff']
        // const color = ['#E77A39', '#ED9E6E', '#FFBC22', '#F5D974', '#FFF2C5']
        // const emphasisColor = ['#f77c33', '#f3a97d', '#fbc343', '#f5df90', '#f9f1d4']
        const pieces = [{
          min: parseFloat(maxNum / 5 * 4)
        }, {
          min: parseFloat(maxNum / 5 * 3),
          max: parseFloat(maxNum / 5 * 4)
        }, {
          min: parseFloat(maxNum / 5 * 2),
          max: parseFloat(maxNum / 5 * 3)
        }, {
          min: parseFloat(maxNum / 5 * 1),
          max: parseFloat(maxNum / 5 * 2)
        }, {
          min: 0.00009,
          max: parseFloat(maxNum / 5 * 1)
        }, {
          min: 0,
          max: 0
        }]
        // 调整处理传过来的数据
        const areaData = result.map(item => {
          return item
        })
        // 调整地图名称和后台传来的名称处理
        const seriesData = res.data.features.map(item => {
          const properties = item.properties
          const findItem = areaData.find(elem => elem.name === properties.name) || {}
          const value = findItem.value || 0
          const colorIndex = pieces.findIndex(item => value >= item.min) || 0
          return {
            name: properties.name,
            value: value,
            itemStyle: {
              emphasis: {
                areaColor: emphasisColor[colorIndex] || '#eeffff'
              }
            }
          }
        })
        const option = this.$chart.chinaMap('达人数量', 'china', seriesData, color, pieces, 0, maxNum * 10)
        const myChart = this.$echarts.init(document.getElementById('china-map'))
        myChart.setOption(option)
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.regional-distribution-model{
  & .china-map{
    width: 55%;
    height: 460px;
    margin-right: 7%;
  }
  & .province-distribution-item{
    & .province-title{
      width: 155px;
    }
    & .institu-sum{
      width: 75px;
    }
    & .institu-rate{
      & .rate-btm{
        width: 100%;
        height: 5px;
        border-radius: 30px;
        background-color: #efefef;
      }
      & .rate-wid{
        top: 0;
        left: 0;
        height: 5px;
        border-radius: 30px;
        background-color: #326CFA;
      }
    }
  }
}
.province-distribution-item{
  & .province-title{
    width: 155px;
  }
  & .institu-sum{
    width: 75px;
  }
  & .institu-rate{
    & .rate-btm{
      width: 100%;
      height: 5px;
      border-radius: 30px;
      background-color: #efefef;
    }
    & .rate-wid{
      top: 0;
      left: 0;
      height: 5px;
      border-radius: 30px;
      background-color: #FFC750;
    }
  }
}
</style>
